let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kofQx")).then(() => parcelRequire('6D0kO'));